export const useFetchListsQueryError = 'useFetchListsQueryError';
